export default __webpack_public_path__ + "static/media/terms.cd330e2e.jpg";